exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-card__body .el-row .el-row[data-v-2c1d1f10] {\n  height: 30px;\n}\n.el-button--mini.is-circle[data-v-2c1d1f10] {\n  padding: 3px;\n}\n", ""]);

// exports
